// noinspection JSUnusedGlobalSymbols
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Performs an HTTP request using the Fetch API with additional plugin-specific configurations.
 *
 * @param {string} url - The URL to which the request is sent. You can use {@link getUrlFactory}.
 * @param {RequestInit} options - The options used to configure the HTTP request, such as method, headers, and body.
 * @return {Promise<any>} A promise that resolves with the parsed JSON response if the request is successful or rejects with an error if the request fails.
 * @throws {Error} If the response is not ok (status code outside the range 200-299), an error is thrown with the status and response message.
 */
export function pluginFetch(url_1) {
    return __awaiter(this, arguments, void 0, function* (url, options = {}) {
        let buildOptions = Object.assign({ method: "GET" }, options);
        buildOptions.headers = Object.assign({ 
            // @ts-ignore PluginHelper
            "X-XSRF-TOKEN": PluginHelper.getCsrfToken() }, buildOptions.headers);
        const response = yield fetch(url, buildOptions);
        let responseJson = undefined;
        try {
            responseJson = yield response.json();
        }
        catch (ignored) {
        }
        if (!response.ok) {
            console.error(`HTTP error! Status: ${response.status} Response: ${JSON.stringify(responseJson)}`);
            throw new Error((responseJson === null || responseJson === void 0 ? void 0 : responseJson.message) || JSON.stringify(response));
        }
        return responseJson;
    });
}
/**
 * Fetches data from the provided URL using {@link pluginFetch} and retrieves the specified key from the response.
 *
 * @param {string} url - The URL to fetch the data from. You can use {@link getUrlFactory}.
 * @param {string} key - The key to extract from the fetched response.
 * @return {Promise<any>} A promise that resolves to the value associated with the specified key in the response, or an empty string if an error occurs.
 */
export function pluginFetchKey(url, key) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield pluginFetch(url);
            return response[key];
        }
        catch (e) {
            console.error("Couldn't get key", e);
            return "";
        }
    });
}
/**
 * Generates a URL creation function for a specific plugin.
 *
 * @param {string} pluginName - The name of the plugin for which the URL factory is being created.
 * @return {(path: string) => string} - A function that takes a path and returns the complete URL for the given plugin. Leading slashes in the path are removed.
 */
export function getUrlFactory(pluginName) {
    return function getUrl(path) {
        // Remove leading slash from path if it exists
        path = path.replace(/^\//, "");
        // @ts-ignore PluginHelper
        return PluginHelper.getPluginRestUrl(`${pluginName}/${path}`);
    };
}
export function getRestUrl(path) {
    // Remove leading slash from path if it exists
    path = path.replace(/^\//, "");
    // @ts-ignore SailPoint
    return SailPoint.getRelativeUrl(`/ui/rest/${path}`);
}
